import axios from "./axiosInstance";

const refundPolicyApi = {
  details: () => axios.post("refund-policy"),
};

export default refundPolicyApi;
